<template>
  <v-container id="document_signature_customization_root" fluid>
    <implicit-authorization-modal
      :key="implicitAuthorizationModalKey"
      :signature-guid="implicitGuid"
      :request-loading-dialog-showed=" ImplicitAuthorizationModalVisible"
    ></implicit-authorization-modal>
    <!-- header -->
    <v-row class="mb-6 px-6" justify="center" align="center">
      <v-btn
        id="back_button"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="back"
      >
        <v-icon
          class="ma-0 pa-0"
          color="grey darken-3"
        >
          mdi-chevron-left
        </v-icon>
        {{ $t('main.back') }}
      </v-btn>
      <v-col cols="7">
        <span id="filename" class="text-h5">
          {{ document.fileName }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn
          v-if="!useExternalSignature"
          id="signature_confirmation_sign_btn"
          class="mx-4 px-4"
          color="success"
          :disabled="!isFormValid"
          :loading="isUploading"
          @click=" (isImplicitCredential(selectedCredential) || isOAUTH2CODECredential(selectedCredential) || isSealSignMode() || isCredentialUnknownAuthMode(selectedCredential))
            ? signDoc()
            : showAuthorizationModal()"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>
          {{ $t('main.sign') }}
        </v-btn>
        <v-btn
          v-if="useExternalSignature"
          id="signature_confirmation_external_sign_btn"
          class="mx-4 px-4"
          color="success"
          :disabled="!uploadedExternalFileName || !uploadedExternalFile || !externalSignatureIdsCorrect"
          :loading="isUploading"
          @click="uploadExternalSignedDocument()"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>
          {{ $t('documentSignatureCustomization.content.signature.externalSignature.submit') }}
        </v-btn>

        <v-btn
          id="decline_btn"
          color="error"
          outlined
          class="px-2"
          :loading="isUploading"
          @click="showDeclineModal($event)"
        >
          <v-icon
            class="mr-1 ml-0"
          >
            mdi-close-circle-outline
          </v-icon>
          {{ $t('dataTable.content.action.decline') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      align="stretch"
      align-content="space-between"
    >
      <v-col md="6" sm="12" align="start">
        <!-- SIGNATURE + CRED  CONFIG-->
        <v-card v-show="pdfRendered">
          <v-container class="d-flex flex-column">
            <v-form ref="form" v-model="formValid" @input="handleFormValidityChange">
              <v-row v-show="pdfRendered">
                <v-col v-if="useExternalSignatureVisible">
                  <v-switch
                    id="use_external_signature"
                    v-model="useExternalSignature"
                    :label="$t('documentSignatureCustomization.content.signature.useExternalSignature')"
                    class="mx-3"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row v-show="pdfRendered && !useExternalSignature">
                <v-col>
                  <v-switch
                    id="set_visible_signature"
                    v-model="useVisibleSignature"
                    :label="$t('documentSignatureCustomization.content.signature.setVisibleSignature')"
                    :disabled="!!predefinedSignatureParams || sealActivated && (credentialsWithCentralKeyToo.length == 1)"
                    class="mx-3"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="!useExternalSignature && useVisibleSignature" class="mb-4">
                <v-btn v-if="!useCustomDrawnSignatureImage" id="draw_signature" class="ml-3 pa-1 pr-2 body-2 white--text modalButton" @click="useCustomSignatureClick">
                  <v-icon>mdi-pen</v-icon>
                  {{ $t('documentSignatureCustomization.content.signature.drawYourSignature') }}
                </v-btn>
                <v-btn
                  v-if="!useCustomDrawnSignatureImage &&
                    !useSignatureProfile &&
                    signatureProfiles.length > 0"
                  id="ChooseSignatureProfile-button"
                  class="ml-3 pa-1 pr-2 body-2 white--text modalButton"
                  @click="useSignatureProfileClick"
                >
                  <v-icon>mdi-form-select</v-icon>
                  {{ $t('documentSignatureCustomization.content.signature.chooseYourSignature') }}
                </v-btn>

                <v-btn v-if="useCustomDrawnSignatureImage" id="draw_signature" class="ml-3 pa-1 pr-2 body-2 white--text modalButton" @click="openSignatureModal">
                  <v-icon>mdi-pen</v-icon>
                  {{ $t('signatureDrawer.title') }}
                </v-btn>

                <v-btn v-if="useCustomDrawnSignatureImage" id="clear_drawed_signature" class="ml-3 pa-1 pr-2 body-2 white--text modalButton" @click="clearCutomSignatureImageClick">
                  <v-icon>mdi-refresh</v-icon>
                  {{ $t('documentSignatureCustomization.content.signature.clearCutomSignatureImage') }}
                </v-btn>
              </v-row>
              <v-row
                v-show="!useExternalSignature && useSignatureProfile"
              >
                <v-col>
                  <v-divider role="presentation"></v-divider>
                  <v-select
                    id="select_signature_profile"
                    v-model="selectedSignatureProfile"
                    class="mx-3 mt-5 mb-4"
                    :items="signatureProfiles"
                    item-text="name"
                    item-value="id"
                    return-object
                    :label="$t('documentSignatureCustomization.content.signature.selectSignatureProfile') + `*`"
                    :rules="[rules.required, rules.credentialAlive]"
                  ></v-select>

                  <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>

                  <v-row align="center" class="mx-3 mb-3">
                    <span>{{ $t('documentSignatureCustomization.content.signature.saveSignaturePosInProfile') }}</span>
                    <v-btn
                      id="save_position_btn"
                      class="mx-3 pa-1"
                      color="success"
                      outlined
                      :disabled="!checkUniquePosition()"
                      @click="saveImagePosToProfile()"
                    >
                      <v-icon class="mr-1 ml-0">{{ saveImagePositionIcon }}</v-icon>
                      {{ $t('main.save') }}
                    </v-btn>
                  </v-row>
                  <v-switch
                    v-show="credentialsWithCentralKeyToo.length > 0"
                    v-model="useDifferentCredential"
                    :label="$t('documentSignatureCustomization.content.signature.useDifferentCredential')"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="!useExternalSignature">
                <v-col
                  v-show="!useVisibleSignature || (useVisibleSignature && !useSignatureProfile) || (useVisibleSignature && useSignatureProfile && useDifferentCredential)"
                >
                  <v-divider role="presentation"></v-divider>
                  <v-select
                    v-if="credentialsWithCentralKeyToo.length > 0"
                    id="signature_customization_credential_select"
                    v-model="selectedCredential"
                    class="mx-3 mt-5"
                    :items="credentialsWithCentralKeyTooComputed"
                    :item-text="getCredentialItemText"
                    :return-object="true"
                    :label="$t('documentSignatureCustomization.content.signature.selectSigningCredential') + `*`"
                    :rules="[rules.requiredSimple]"
                  >
                    <!-- <template v-slot.item="{item}">
                      <div class="option_active_credential">
                        {{ item }}
                      </div>
                    </template> -->
                  </v-select>
                  <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>
                </v-col>
              </v-row>
              <v-row v-if="useExternalSignature">
                <v-col>
                  <v-btn
                    id="download-document-external-signature"
                    class="mx-4 px-4"
                    @click="downloadForExternalSign()"
                  >
                    <v-icon class="mr-1 ml-0">mdi-download</v-icon>
                    {{ $t("documentSignatureCustomization.content.signature.externalSignature.download") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="useExternalSignature">
                <v-col>
                  <drag-drop-upload
                    id="upload_file" :key="dragDropKey" given-height="20vh" max-width="auto"
                    :valid-formats="['application/pdf']" :current-file="uploadedExternalFile" :single-file="true" :upload-caption="$t('documentSignatureCustomization.content.signature.externalSignature.upload')" :description="$t('dragDrop.uploadFiles')"
                    @uploaded="handleExternalSignatureUploaded"
                  >
                    <v-progress-circular
                      v-if="isUploading" slot="progress-bar" indeterminate color="primary"
                      class="mb-4"
                    ></v-progress-circular>
                  </drag-drop-upload>
                </v-col>
              </v-row>
            </v-form>

            <v-row class="pa-3">
              <v-text-field
                id="comment_text_field"
                v-model="comment"
                prepend-icon="mdi-comment modalButtonColor--text large"
                persistent-hint
              >
                <template #label>
                  <span class="text--secondary">{{ $t('documentSignatureCustomization.comments.label') }}</span>
                </template>
              </v-text-field>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!-- visibleSignatureComponent -->
      <v-col
        cols="6"
        md="6"
        sm="12"
        align="center"
        style="position: relative;"
      >
        <v-overlay
          :absolute="true"
          :value="isUploading"
        >
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <visibleSignature
          ref="visibleSignature"
          :doc-data="documentBase64"
          :sign-prof="selectedSignatureProfile"
          :pdf-encrypted.sync="pdfEncrypted"
          :allow-sign-profile-editing="!predefinedSignatureParams"
          @updatedSignProf="updatedSignatureProfile"
          @updatedTextSize="updatedTextSize"
          @updatedSignatureProfileImage="updatedSignatureProfileImage"
          @pdfLoaded="pdfLoaded"
          @passwordSpecified="onPDFPasswordSpecified"
          @passwordCancelled="handlePasswordCancelled"
        />
      </v-col>
    </v-row>
    <!-- authorizationModal -->
    <v-row justify="center">
      <v-dialog v-model="authorizationModal" persistent max-width="500">
        <v-card id="explicit_auth_modal">
          <v-card-title>
            <span class="headline">{{ $t('documentSignatureCustomization.modal.authorization.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="authorizationModalForm" v-model="authorizationModalFormValid" @submit.prevent>
              <v-text-field
                id="explicit_authmodal_textfield"
                ref="passwordField"
                v-model="expAuthPwd.pwd"
                tabindex="1"
                :append-icon="expAuthPwd.showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('documentSignatureCustomization.modal.authorization.content.keyPassword') + `*`"
                :type="expAuthPwd.showPwd ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :rules="[rules.required, rules.passwordMustBeLongerThan]"
                @click:append="expAuthPwd.showPwd = !expAuthPwd.showPwd"
                @keydown.enter="signDoc()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text tabindex="3" @click="authorizationModal = false">{{ $t('main.cancel') }}</v-btn>
            <v-btn
              id="explicit_authmodal_signbtn"
              color="success"
              tabindex="2"
              :disabled="!authorizationModalFormValid"
              :loading="authorizationModalBtnLoading"
              @click="signDoc()"
            >
              {{ $t('documentSignatureCustomization.modal.authorization.content.button.sign') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noCredentialWarningVisible" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedCredential.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.noActivatedCredential.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/credentials"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.noActivatedCredential.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="notVerifiedUserWarningVisible" persistent width="auto" max-width="700">
        <v-card id="not_verifiedUser_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.notVerifiedUser.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.notVerifiedUser.description') }}
            </div>
            <v-btn
              id="not_verified_user_warning_ok"
              style="text-align: center;"
              color="primary"
              class="mt-10 mb-0"
              to="/user/profile"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.notVerifiedUser.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noDeviceForImplicitCredentialWarningVisible" persistent max-width="550">
        <v-card id="no_device_warning" class="pa-6">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedDevice.title') }}
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="start">
                <div>
                  {{ $t('signatureProfiles.error.noActivatedDevice.description') }}
                </div>
                <div class="pt-6">
                  <v-btn
                    id="no_device_warning_ok"
                    color="primary"
                    to="/user/profile/"
                    class=" mb-0"
                  >
                    <v-icon class="mr-1">mdi-cellphone-key</v-icon>
                    {{ $t('signatureProfiles.error.noActivatedDevice.button') }}
                  </v-btn>
                </div>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible" persistent width="auto" max-width="700">
        <v-card id="centralKey_Enabled_And_noProfile_WithCentralKey_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.description') }}
            </div>
            <v-btn
              id="centralKey_Enabled_And_noProfile_WithCentralKey_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/signatureProfiles"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible" persistent width="auto" max-width="700">
        <v-card id="centralKey_Enabled_And_noProfile_WithCentralKey_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.description') }}
            </div>
            <v-btn
              id="centralKey_Enabled_And_noProfile_WithCentralKey_warning_ok"
              style="text-align: center;"
              color="primary"
              to="/signatureProfiles"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <decline-reason-modal
        :visible="declineReasonVisible"
        :signature-id="+$route.params.signatureId"
        :current-signature-id="$route.params.currentSignatureId"
        @declined="back"
        @closed="declineReasonVisible = false"
      ></decline-reason-modal>
    </v-row>
    <v-row>
      <signature-drawer ref="signatureDrawer" v-model="showSignatureModal" @saved="handleCustomSignature"></signature-drawer>
    </v-row>
  </v-container>
</template>

<script>

import SignatureDrawer from '@/components/SignatureDrawer.vue'
import rssp from '@/services/api/rsspUtil.js'
import seal from '@/services/api/seal.js'
import memberRole from '@/views/signature/chains/memberRole'
import { UserManager } from 'oidc-client-ts'
import { v4 as uuidv4 } from 'uuid'
import VisibleSignature from '../../components/VisibleSignature'
import { showConfirmationMenu, showRequestLoadingDialog, showToastError, showToastSuccess } from '../../event-bus'
import credentialRefs from '@/services/api/credentialRefs'
import evro from '@/services/api/evro'
import csc from '@/services/api/csc'
import documents from '../../services/api/documents'
import signatureProfiles from '../../services/api/signatureProfiles'
import signatures from '../../services/api/signatures'
import userVerification from '../../services/api/userVerification'
import users from '../../services/api/users'
import CommonError from '../CommonError'
import CredentialAuthMode from './CredentialAuthMode'
import DeclineReasonModal from './DeclineReasonModal'
import ImplicitAuthorizationModal from './ImplicitAuthorizationModal'
import DragDropUpload from '@/components/DragDropUpload.vue'
import documentDownloadMode from '@/views/signature/chains/documentDownloadMode.js'
import FileSaver from 'file-saver'
import signatureChains from '@/services/api/signatureChains'
import signatureChainType from '@/views/signature/chains/SignatureChainType'

export default {
  name: 'DocumentSignatureCustomization',
  components: {
    SignatureDrawer,
    VisibleSignature,
    ImplicitAuthorizationModal,
    DeclineReasonModal,
    DragDropUpload
  },

  data() {
    return {
      formValid: true,
      evroEnabled: this.$store.state.remoteConfig.evroEnabled ? this.$store.state.remoteConfig.evroEnabled : false,
      documentBase64: null,
      document: {},
      pdfRendered: false,
      useVisibleSignature: this.$route.query.originX && this.$route.query.originY && this.$route.query.page && this.$route.query.height && this.$route.query.width,
      useSignatureProfile: false,
      useDifferentCredential: false,
      useCustomDrawnSignatureImage: false,
      userDrawedSignatureImage: null,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      rsspRemoteConf: null,
      externalSignaturesEnabled: this.$store.state.remoteConfig.externalSignaturesEnabled ? this.$store.state.remoteConfig.externalSignaturesEnabled : false,
      useExternalSignature: false,
      externalSignatureIdsCorrect: false,
      chain: null,
      dragDropKey: 0,
      signatureProfiles: [],
      selectedSignatureProfile: {
        credentialId: ''
      },
      signatureImg: null,
      signatureTextSize: 14,
      pdfEncrypted: false,
      pdf_password: null,
      activatedCredentials: [],
      credentialRefs: [],
      credentialsEvro: [],
      myCredentials: [],
      providers: null,
      idToken: null,
      credentialsWithCentralKeyToo: [],
      selectedCredential: null,
      switchSignatureChainType: false,
      draftRecipients: [{ userId: null }],
      authorizationModalFormValid: false,
      authorizationModal: false,
      authorizationModalBtnLoading: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      implicitGuid: '',
      devicesListTotalItems: 0,
      devicesActiveTotalItems: 0,
      ImplicitAuthorizationModalVisible: false,
      showBlueWarning: false,
      noCredentialWarningVisible: false,
      noDeviceForCredentialWarningVisible: false,
      noDeviceForImplicitCredentialWarningVisible: false,
      notVerifiedUserWarningVisible: false,
      centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible: false,
      user: null,
      authorizationTimeoutMilis: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000 : null,
      evroTrustAuthorizationTimeoutMilis: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.evroAuthorizationTimeoutSecs * 1000 : 60 * 1000,
      showSignatureModal: false,
      // centralKeyId: 'central_key_id',
      centralKeyId: -1,
      originalSignatureProfiles: [],
      userVerificationStatus: {
        verified: true,
        fields: [
          { id: 'SURNAME', displayName: 'vezetéknév', optional: true, value: 'Surname value' },
          // { id: 'GIVEN_NAMES', displayName: 'keresztnév', optional: true, value: 'Given value' },
          { id: 'GIVEN_NAMES', displayName: 'keresztnév', optional: false },
          { id: 'NATIONALITY', displayName: 'nemzetiség', optional: false, value: 'Magyar' }
        ]
      },
      expAuthPwd: {
        pwd: null,
        showPwd: false
      },
      uploadedExternalFile: null,
      uploadedExternalFileName: null,
      passwordMinCharacters: 6,
      rules: {
        requiredSimple: v => !!v || this.$t('validation.form.requiredField'),
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        passwordMustBeLongerThan: v => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters }),
        onlyNumber: v => (/^[0-9]+$/.test(v)) || this.$t('validation.form.onlyNumbers'),
        // credentialAlive: (v) => (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
        credentialAlive: (v) => {
          if (!this.useSignatureProfile) {
            return true
          }
          const isEvroCred = !!(this.selectedCredential && this.selectedCredential.isEvro)
          const isCredRef = !!(this.selectedCredential && this.selectedCredential.provider)
          // const searchingForCredId = this.useSignatureProfile && !this.useDifferentCredential ? parseInt(this.selectedSignatureProfile.credentialId) : this.selectedCredential?.id
          const searchingForCredId = !this.useDifferentCredential ? parseInt(this.selectedSignatureProfile.credentialId) : this.selectedCredential?.id
          const foundCred = !!(this.activatedCredentials.find(cred => cred.id === searchingForCredId))
          const existActvatedCred = (!!(!!this.selectedCredential && foundCred))
          if (this.sealActivated) {
            // profil, nem másik jog használata
            if (this.useSignatureProfile && !this.useDifferentCredential && this.selectedSignatureProfile.useSeal) {
              return this.sealActivated || this.$t('validation.form.centralKeyIsNotActivated')
            } else
            if (this.useSignatureProfile) {
              // console.log('credentialAlive 2 this.selectedSignatureProfile.useSeal', this.selectedSignatureProfile.useSeal)
              // console.log('credentialAlive 2 this.selectedCredential', this.selectedCredential)
              if (this.selectedSignatureProfile.useSeal && this.useDifferentCredential && (!this.selectedCredential || (!this.selectedCredential.id && !this.selectedCredential.credentialRefId && !this.selectedCredential.isEvro))) {
                // console.log('credentialAlive 2 exiting')
                return true
              }
              if (this.useSignatureProfile && this.useDifferentCredential && (this.selectedCredential && (this.selectedCredential.id === -1))) {
                return true
              }

              const res = ((!this.useDifferentCredential && existActvatedCred) || this.useDifferentCredential || isCredRef || isEvroCred)

              return (!!res) || this.$t('validation.form.credentialIsDead')
              // return true
            }
            return true
          } else {
            // const res = (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedSignatureProfile.credentialId) !== undefined) || !!this.selectedCredential.id))) || (this.selectedCredential && this.selectedCredential.provider) || (this.selectedCredential && this.selectedCredential.isEvro) || this.$t('validation.form.credentialIsDead')
            // const res = existActvatedCred || isCredRef || isEvroCred || this.$t('validation.form.credentialIsDead')
            const res = ((!this.useDifferentCredential && existActvatedCred) || this.useDifferentCredential || isCredRef || isEvroCred) || this.$t('validation.form.credentialIsDead')

            return res
          }
        }
      },

      isUploading: true,

      // decline reasoning:
      declineReasonVisible: false,
      // save image postion :
      saveImagePositionIcon: 'mdi-content-save-outline',
      popupLoginWidth: this.$store.state.remoteConfig.popupLogin?.width ?? 770,
      popupLoginHeight: this.$store.state.remoteConfig.popupLogin?.height ?? 720,
      comment: ''
    }
  },

  computed: {
    useExternalSignatureVisible() {
      return this.externalSignaturesEnabled && (this.chain) && (this.chain.signingTrailMode !== 'DETACHED')
    },
    predefinedSignatureParams() {
      const { originX, originY, width, height, page } = this.$route.query
      if ([originX, originY, width, height, page].every(v => v === undefined)) {
        return null
      }
      const parsed = {
        originX: parseFloat(originX),
        originY: parseFloat(originY),
        width: parseFloat(width),
        height: parseFloat(height),
        page: parseInt(page)
      }

      const isValid =
      !isNaN(parsed.originX) &&
      !isNaN(parsed.originY) &&
      !isNaN(parsed.width) &&
      !isNaN(parsed.height) &&
      !isNaN(parsed.page)

      return isValid ? parsed : null
    },
    currentUser() {
      return this.$store.state.currentUser
    },

    // from validating not working correctly on this page, so made this not so nice hack. todo: fix the validation issues
    isFormValid() {
      const isSigner = this.hasRoleInternal(memberRole.SIGNER.toLowerCase())
      if (!isSigner) {
        return false
      }
      //

      // const noSignatureProfileUsedError = !this.useSignatureProfile && (!this.sealActivated || ((this.selectedCredential === null) || (!this.selectedCredential.id)))
      if (this.sealActivated && !this.useSignatureProfile && (!this.selectedCredential || !this.selectedCredential.id)) {
        return false
      }
      if (!this.useSignatureProfile && this.useVisibleSignature && !this.userDrawedSignatureImage) {
        return false
      }

      // const sealProfileValid = !this.sealActivated || !!(this.sealActivated && this.useSignatureProfile && this.selectedSignatureProfile.useSeal)
      const selectedCredIsImplicit = this.selectedCredential && this.isImplicitCredential(this.selectedCredential)
      const implicitValid = !selectedCredIsImplicit || (selectedCredIsImplicit && (this.devicesActiveTotalItems > 0))
      // console.log('isFormValid implicitValid', implicitValid)
      // console.log('isFormValid this.selectedSignatureProfile', this.selectedSignatureProfile)
      // console.log('isFormValid sealProfileValid', sealProfileValid)

      const formValidRes = this.formValid
      // formValidRes = true // todo: harcoded workaround because formValid returns false even when no error exist for the form
      // console.log('isFormValid formValidRes', formValidRes)
      // const res = formValidRes && implicitValid && sealProfileValid
      const res = formValidRes && implicitValid
      // const res = !noSignatureProfileUsedError && !SignatureProfileUsedError
      // console.log('isFormValid res', res)
      return res
    },

    sealActivated() {
      return this.sealStatus.enabled && this.sealStatus.activated
    },

    sealEnabled() {
      return this.sealStatus.enabled
    },

    isVerificationEnabled() {
      return !!this.$store.state.remoteConfig.regulaEnabled
    },
    credentialsWithCentralKeyTooComputed() {
      return this.credentialsWithCentralKeyToo.map((item, index) => {
        if (this.sealActivated) {
          const centralKeyDisabled = (this.sealActivated && !this.useVisibleSignature) || (this.useDifferentCredential && this.useSignatureProfile && (this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal))

          if (index === 0 && centralKeyDisabled) {
            return {
              ...item,
              disabled: true
            }
          }
          return item
        } else {
          return item
        }
      })
    }
  },

  watch: {
    async selectedSignatureProfile(val, oldVal) {
      if (!val) {
        this.selectedCredential = {}
        return
      }

      if (val?.id !== oldVal?.id) {
        if (!val?.savedSignatureFieldParameters) {
          val.savedSignatureFieldParameters = {
            originX: 0,
            originY: 0
          }
        }
      }

      if (this.predefinedSignatureParams) {
        const { originX, originY, width, height, page } = this.$route.query
        val.savedSignatureFieldParameters = {
          originX: parseFloat(originX),
          originY: parseFloat(originY),
          width: width ? parseFloat(width) : undefined,
          height: height ? parseFloat(height) : undefined,
          page: parseInt(page)
        }
      }
      if (val.credentialRefId || val.evroRefId || val.credentialId) {
        if (this.sealEnabled && (val.useSeal)) {
          if (!this.selectedCredential) {
            this.selectedCredential = {}
          }
          if (val.credentialRefId) {
            this.selectedCredential.id = parseInt(val.credentialRefId)
          } else
          if (val.evroRefId) {
            this.selectedCredential.id = parseInt(val.evroRefId)
            this.selectedCredential.isEvro = true
          }
          // console.log('central key selected', this.selectedCredential)
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.checkFormValidity()
            }
          })
        } else {
          if (val.credentialRefId) {
            this.selectedCredential = this.findCredentialByRefId(parseInt(val.credentialRefId))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              // console.log('this.selectedCredential is empty, this.credentialsWithCentralKeyToo', this.credentialsWithCentralKeyToo)
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(val.credentialRefId)
            }
          } else
          if (val.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(parseInt(val.evroRefId))
            // console.log('val.evroRefId ág selectedCredential', this.selectedCredential)
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              // console.log('this.selectedCredential is empty, this.credentialsWithCentralKeyToo', this.credentialsWithCentralKeyToo)
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(val.evroRefId)
              this.selectedCredential.isEvro = true
            }
          } else {
            this.selectedCredential = this.findCredentialById(parseInt(val.credentialId))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              // console.log('this.selectedCredential is empty, this.credentialsWithCentralKeyToo', this.credentialsWithCentralKeyToo)
              // console.log('this.selectedCredential is empty')
              this.selectedCredential = {}
              // this.selectedCredential.id = parseInt(val.credentialId)
            }
          }
          if (!this.selectedCredential) {

          }

          this.$nextTick(() => {
            if (this.$refs.form) {
              this.checkFormValidity()
            }
          })
        }
      } else {
        if (!this.sealEnabled) {
          // console.log('no credential id in profile')
        }
        // console.log('no id in profile')
        this.selectedCredential = {}
        if (this.useSignatureProfile && this.selectedSignatureProfile.useSeal && this.sealActivated) {
          // this.selectedCredential.id = this.centralKeyId
          this.selectedCredential = this.findCredentialById(-1)
        }
        // this.selectedCredential.id = this.centralKeyId
        this.$refs.form.resetValidation()
      }
      // console.log('calling getVisibleSignature for id', profile.id)
      if (this.useVisibleSignature && this.useSignatureProfile && !this.selectedSignatureProfile.sourceImageDataUrl) {
        signatures.getVisibleSignature(this.selectedSignatureProfile.id)
          .then(visResp => {
            // console.log('visResp', visResp)
            this.selectedSignatureProfile.sourceImageDataUrl = visResp.data.imageDataUrl
            // console.log('profile after visResp', this.selectedSignatureProfile)
            this.$nextTick(() => {
              const visibleSignatureComponent = this.$refs.visibleSignature
              visibleSignatureComponent.updateSignatureProfile(this.selectedSignatureProfile)
            })
          })
      } else {
        // console.log('profile have sourceImageDataUrl, not calling visResp')
      }
      // console.debug('Signature profile selected this.selectedCredential', this.selectedCredential)
    },
    async selectedCredential(val) {
      if (val && val.provider) {
        const credInfo = await this.getCredentialInfosWithCSC()
        // console.log('credref credentialsInfo', credInfo)
      }
      // console.log('selectedCredential watcher', this.selectedCredential)
      if (this.selectedCredential && this.selectedCredential.id === undefined) {
        // console.log('selectedCredential has no id, probably corrupted state, fixing')
        this.selectedCredential = null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    },

    async useDifferentCredential(val) {
      if (!val) {
        if (!this.useSignatureProfile) {
          this.selectedCredential = {}
        } else
        if (this.selectedSignatureProfile) {
          if (this.selectedSignatureProfile.credentialRefId) {
            this.selectedCredential = this.findCredentialByRefId(parseInt(this.selectedSignatureProfile.credentialRefId))
            const credInfo = this.getCredentialInfosWithCSC()
            // console.log('credref credentialsInfo', credInfo)
          } else
          if (this.selectedSignatureProfile.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(parseInt(this.selectedSignatureProfile.evroRefId))
          } else {
            this.selectedCredential = this.findCredentialById(parseInt(this.selectedSignatureProfile.credentialId))
          }
        }
        if (this.sealActivated && (this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal)) {
          // this.selectedCredential.id = this.centralKeyId
          this.selectedCredential = this.findCredentialById(-1)
        }
      } else {
        this.selectedCredential = undefined
      }

      // this.$refs.form.resetValidation()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    },

    async useSignatureProfile(val) {
      if (val) {
        // this.selectedCredential = {}
      } else {
        this.selectedSignatureProfile = {}
      }
      this.$refs.form.resetValidation()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    },
    async useVisibleSignature(val) {
      if (val) {
        if (this.signatureProfiles.length > 0) {
          this.useSignatureProfile = true
          this.selectedSignatureProfile = this.signatureProfiles[0]
        }
      }
      this.useDifferentCredential = false
      if (!val) {
        this.useSignatureProfile = false
      }
      this.$refs.form.resetValidation()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.checkFormValidity()
        }
      })
    }
  },

  async mounted() {
    await this.downloadDocument()
    await this.getSignatureProfiles()

    this.sealStatus = await seal.getSealStatus()
    // console.log('sealStatus', this.sealStatus)
    await this.listMyActivatedCredentials()
    // console.log('this.activatedCredentials', this.activatedCredentials)

    await this.listImportedCredentials()
    // console.log('credRefs', this.credentialRefs)

    this.useVisibleSignature = !!this.predefinedSignatureParams

    this.credentialsWithCentralKeyToo = [...this.activatedCredentials, ...this.credentialRefs, ...this.credentialsEvro]
    // console.log('this.sealActivated', this.sealActivated)
    if (this.sealActivated) {
      this.credentialsWithCentralKeyToo.unshift({ id: -1, description: this.$t('documentSignatureCustomization.content.signature.centralKey') })
      if (this.credentialsWithCentralKeyToo.length === 1) {
        this.useVisibleSignature = true
      }
    }

    // console.log('credentialsWithCentralKeyToo', this.credentialsWithCentralKeyToo)

    this.user = await users.getMyUser()
    // this.user.verified = true // todo remove in production
    this.notVerifiedUserWarningVisible = this.isVerificationEnabled && this.user && this.user.verificationMandatory && !this.user.verified
    if (this.isVerificationEnabled) {
      this.getVerificationDetails()
    }

    this.providers = await credentialRefs.getExternalProviders('web')
    // console.log('external providers', this.providers)

    this.$nextTick(() => {
      if (this.$refs.form) {
        this.checkFormValidity()
      }
    })

    await this.handleWarning()

    if (this.sealActivated && !this.useSignatureProfile && this.signatureProfiles.length === 0 && (this.credentialsWithCentralKeyToo.length === 1)) {
      this.$nextTick(() => {
        this.selectedCredential = this.findCredentialById(-1)
      })
    }

    if (this.externalSignaturesEnabled) {
      this.chain = await signatureChains.getSignatureChain(this.$route.params.chainId)
    }

    if (this.hasPredefinedSignatureParameters) {
      const { x, y, width, height, page } = this.$route.query
      this.selectedSignatureProfile.savedSignatureFieldParameters = {
        originX: parseInt(x),
        originY: parseInt(y),
        width: parseInt(width),
        height: parseInt(height),
        page: parseInt(page)
      }

      this.$nextTick(() => {
        const visibleSignatureComponent = this.$refs.visibleSignature
        if (visibleSignatureComponent) {
          visibleSignatureComponent.updateSignatureProfile(this.selectedSignatureProfile)
        }
      })
    }
  },

  methods: {
    async getCredentialIdFromRef(credentialRefId) {
      const ref = await credentialRefs.getCredentialRef(credentialRefId)
      return ref.credentialId
    },

    async saveImagePosToProfile() {
      // console.debug('Updating signature profile with new position', this.selectedSignatureProfile)
      try {
        const profileNeedToSaveOriginal = this.originalSignatureProfiles.find(obj => obj.id === this.selectedSignatureProfile.id)
        // console.log('this.originalSignatureProfiles', this.originalSignatureProfiles)
        // console.log('profileNeedToSaveOriginal', profileNeedToSaveOriginal)
        const profileNeedToSave = JSON.parse(JSON.stringify(profileNeedToSaveOriginal))

        const visibleSignature = this.$refs.visibleSignature
        const usedSignatureFieldParameters = visibleSignature.getSignatureFieldParameters()
        // console.log('this.useSignatureProfile', this.useSignatureProfile, usedSignatureFieldParameters)
        if (this.useSignatureProfile && usedSignatureFieldParameters) {
          this.$set(profileNeedToSave, 'savedSignatureFieldParameters', { ...usedSignatureFieldParameters })

          this.$set(this.selectedSignatureProfile, 'savedSignatureFieldParameters', { ...usedSignatureFieldParameters })
        }

        await signatureProfiles.updateMySignatureProfile(profileNeedToSave.id, profileNeedToSave)
        this.saveImagePositionIcon = 'mdi-content-save-check-outline'
        this.$nextTick(() => {
          this.checkUniquePosition()
        })
      } catch (error) {
        console.error(error)
      }
    },

    async downloadDocument() {
      this.isUploading = true
      try {
        const blob = await documents.downloadDocument(this.$route.params.docId)
        const docuDto = await documents.getDocument(this.$route.params.docId)
        this.document = docuDto
        this.pdfEncrypted = (docuDto.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (docuDto.security === 'ENCRYPTED_WITH_USER_PASSWORD')
        const base64 = await this.blobToBase64(blob)
        this.documentBase64 = base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    handlePasswordCancelled() {
      showToastError(this.$t('toastMessage.cantDisplayPDFWithoutPasswordSpecified'))
      this.$router.push({ name: 'SignatureChains' })
    },

    onPDFPasswordSpecified(password) {
      this.pdf_password = password
    },

    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    async getSignatureProfiles() {
      try {
        this.signatureProfiles = await signatureProfiles.getSignatureProfiles()
        this.originalSignatureProfiles = JSON.parse(JSON.stringify(this.signatureProfiles))
        // console.log('originalSignatureProfiles', JSON.parse(JSON.stringify(this.originalSignatureProfiles)))

        this.signatureProfiles.forEach(profile => {
          delete profile.textParams
          // deleting the sourceImageDataUrl here, because we will use the dynamically rendered image later, when profile first selected
          delete profile.sourceImageDataUrl
        })

        // console.log('this.signatureProfiles', this.signatureProfiles)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listMyActivatedCredentials() {
      try {
        const resp = await rssp.listMyActivatedCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN') && (elem.certChain.length > 0)))

        this.activatedCredentials = resp.content
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listImportedCredentials() {
      try {
        const pageRequestImported = {
          'page-num': 1,
          'page-size': 50,
          'sort-field': 'user.name',
          'sort-order': 'desc'
        }

        const pageImported = await credentialRefs.listCredentialRefs(null, null, pageRequestImported)
        // console.log('credRefs', pageImported)

        this.credentialRefs = pageImported.content

        if (this.evroEnabled) {
          const pageEvroImported = await evro.listEvroRefs(null, null, pageRequestImported)
          pageEvroImported.content = pageEvroImported.content.map(item => {
            return {
              ...item,
              isEvro: true
            }
          })
          this.credentialsEvro = pageEvroImported.content
        }
        this.haveImportedcontent = (pageImported.content.length > 0) || (this.credentialsEvro.length > 0)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async handleWarning() {
      try {
        const resp = await rssp.listMyCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN')))
        this.myCredentials = resp.content

        const devices = await rssp.listMyDevices()
        // console.log('devices', devices)
        this.devicesListTotalItems = devices.total

        const credentialActivatedImplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'IMPLICIT').length
        const credentialActivatedExplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'EXPLICIT').length
        const credentialImplicitTotalItems = this.myCredentials.filter(x => x.authMode === 'IMPLICIT').length
        this.devicesActiveTotalItems = devices.content.filter(x => x.enabled === true).length

        this.noDeviceForImplicitCredentialWarningVisible = !this.sealActivated && (credentialActivatedExplicitTotalItems === 0) && (this.devicesListTotalItems === 0) && (credentialImplicitTotalItems > 0)
        this.noCredentialWarningVisible = !this.sealActivated && !this.noDeviceForImplicitCredentialWarningVisible && (this.activatedCredentials.length === 0) && (this.credentialRefs.length === 0)
        this.showBlueWarning = (this.myCredentials.filter(x => x.status !== 'ACTIVATED' || x.certChain.length === 0).length > 0) || (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0)
        if (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems > 0 && this.devicesActiveTotalItems === 0) {
          this.showBlueWarning = true
        }
        // console.log('showBlueWarning', this.showBlueWarning)

        if (!this.noDeviceForImplicitCredentialWarningVisible && !!this.noCredentialWarningVisible && this.sealActivated && (this.signatureProfiles.length > 0) && (this.activatedCredentials.length === 0) && (this.credentialRefs.length === 0)) {
          this.centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible = !this.signatureProfiles.find(profile => profile.useSeal === true)
        } else {
          this.centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible = false
        }
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    updatedSignatureProfile(variable) {
      // console.log('updatedSignatureProfile', variable)
      // this.selectedSignatureProfile = variable
    },

    updatedTextSize(variable) {
      this.signatureTextSize = variable
    },

    async updatedSignatureProfileImage(variable) {
      // console.debug('updatedSignatureProfileImage', variable)
      this.signatureImg = variable
    },

    pdfLoaded(variable) {
      this.pdfRendered = true
      this.isUploading = false
      // console.debug('pdfLoaded')

      if (this.sealActivated && this.activatedCredentials.length === 0 && this.credentialRefs.length === 0 && this.credentialsEvro.length === 0 && this.signatureProfiles.length === 1) {
        this.useSignatureProfile = true
        this.selectedSignatureProfile = this.signatureProfiles[0]
        if (!this.selectedCredential) {
          this.selectedCredential = {}
        }
        if (this.selectedSignatureProfile.credentialRefId || this.selectedSignatureProfile.evroRefId || this.selectedSignatureProfile.credentialId) {
          this.selectedCredential.id = this.selectedSignatureProfile.credentialRefId ? this.selectedSignatureProfile.credentialRefId : parseInt(this.selectedSignatureProfile.credentialId)
        }
        // console.log('this.selectedCredential', this.selectedCredential)
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.checkFormValidity()
          }
        })

        const visibleSignatureComponent = this.$refs.visibleSignature
        if (!visibleSignatureComponent.isFabricControlsInited()) {
          visibleSignatureComponent.redrawEverything()
        }
      }
    },

    showAuthorizationModal() {
      if (!this.$refs.form.validate()) {
        console.log('showAuthorizationModal Form has errors')
        return
      }
      this.authorizationModal = true
      this.$nextTick(() => {
        this.$refs.authorizationModalForm.reset()
        this.$nextTick(() => {
          this.$refs.passwordField.focus()
        })
      })
    },

    async showDeclineModal(e) {
      const opts = {
        title: this.$t('dialog.confirmation.title'),
        posX: e.clientX,
        posY: e.clientY
      }
      const conf = await showConfirmationMenu(opts)
      if (!conf) {
        return
      }
      this.declineReasonVisible = true
    },

    checkUniquePosition() {
      if (!this.selectedSignatureProfile?.id) return false
      if (!this.selectedSignatureProfile.savedSignatureFieldParameters) return false
      const p = JSON.parse(JSON.stringify(this.selectedSignatureProfile.savedSignatureFieldParameters))

      const visibleSignature = this.$refs.visibleSignature
      const actualParams = visibleSignature.getSignatureFieldParameters()

      // console.log('checkUniquePosition p?.originX és Y', p?.page, p?.originX, p?.originY)
      // console.log('checkUniquePosition actualParams', actualParams)

      if (actualParams) {
        const isInDefaultPos = p?.originX === actualParams.originX && p?.originY === actualParams.originY && (p?.page ? p?.page : 1) === actualParams.page
        /* console.log('page check', p?.page === actualParams.page)
        console.log('originX check', p?.originX === actualParams.originX)
        console.log('originY check', p?.originY === actualParams.originY)
        console.log('!isInDefaultPos', !isInDefaultPos) */
        return !isInDefaultPos
      } else {
        return false
      }
    },

    getCurrentProvider() {
      return this.providers.find(provider => provider.id === this.selectedCredential.provider)
    },

    getExternalProviderRDSSBaseURL(providerId) {
      return this.$store.state.remoteConfig.rdssApiUrl + '/v1/extproviders/' + providerId
    },

    handleCSCErrorMessage(error) {
      if (error.message) {
        return this.$t('toastMessage.errorDuringPopupLoginWithDetails', { msg: error.message })
      } else {
        return this.$t('toastMessage.errorDuringPopupLogin')
      }
    },

    async getCredentialInfosWithCSC() {
      const foundProvider = this.getCurrentProvider()
      // console.log('foundProvider', foundProvider)
      const usedOIDC = foundProvider.oidc
      let providerBaseURL

      if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
        providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
      } else {
        providerBaseURL = foundProvider.apiBaseUrl
      }

      if (!this.selectedCredential.idToken) {
        let oldIdToken = null
        if (foundProvider.id === this.$popupAuth.settings.providerId) {
          const user = await this.$popupAuth.getUser()
          // console.log('external provider user', user)
          try {
            oldIdToken = user ? await this.$popupAuth.getIdToken() : null
            // this.id_token = user ? user.id_token : null
            if (user && !oldIdToken) {
              // console.log('Empty id_token, using access_token instead', user.access_token)
              // this.id_token = user.access_token
              oldIdToken = await this.$popupAuth.getAccessToken()
            }
          } catch (Err) {
            oldIdToken = null
          }
          // console.log('oldIdToken', oldIdToken)
        }
        if (oldIdToken && (foundProvider.id === this.$popupAuth.settings.providerId)) {
          this.selectedCredential.idToken = oldIdToken
          // console.log('using already loggedin external provider token')
        } else {
          const settings = {
            authority: usedOIDC.issuer,
            apiBaseUrl: providerBaseURL,
            providerId: foundProvider.id,
            client_id: usedOIDC.clientId,
            response_type: 'code',
            scope: usedOIDC.scope,
            prompt: usedOIDC.prompt,
            monitorSession: false,
            popupWindowFeatures: `location=no,toolbar=no,width=${this.popupLoginWidth},height=${this.popupLoginHeight},left=100,top=100`
          }
          if (usedOIDC.clientSecret) {
            settings.client_secret = usedOIDC.clientSecret
          }

          if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
            settings.metadata = {
              authorization_endpoint: usedOIDC.authorizationEndpoint,
              // token_endpoint: usedOIDC.tokenEndpoint,
              token_endpoint: providerBaseURL + '/openid/token',
              revocation_endpoint: usedOIDC.revocationEndpoint
            }
          }
          this.$popupAuth.setSettings(settings)
          try {
            const user = await this.$popupAuth.login()
            // console.log('User logged in', user)
            this.selectedCredential.idToken = user.access_token
            if (!user.id_token) {
              // console.log('Empty id_token, using access_token instead', user.access_token)
              this.selectedCredential.idToken = user.access_token
            } else {
              this.selectedCredential.idToken = user.id_token
            }
            // console.log('id_token', this.selectedCredential.idToken)
          } catch (error) {
            console.error('An error occured during login.', error)
            showToastError(this.handleCSCErrorMessage(error))
            return null
          }
        }
      }

      if (!this.selectedCredential.idToken) {
        showToastError(this.$t('importCredential.loginError'))
        return null
      } else {
        // console.log('selectedCredential', this.selectedCredential)
        const req = {
          // credentialID: this.selectedCredential.credentialId ? parseInt(this.selectedCredential.credentialId) : parseInt(this.selectedCredential.id)
          credentialID: this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id
          /*,
          certInfo: null,
          certificates: 'none' */
        }
        const resp = await csc.credentialsInfo(providerBaseURL, this.selectedCredential.idToken, req)
        this.selectedCredential.authMode = resp.authMode.toUpperCase()

        this.selectedCredential.cert = resp.cert
        this.selectedCredential.providerBaseURL = providerBaseURL
        // console.log('credref csc credentialsInfo', resp)
        // console.log('credref csc credentialsInfo certificate', resp.cert)
        return resp
      }
    },

    extractDocHashes(jsonArray) {
      return jsonArray.map(item => item.docHash)
    },

    updateDocHashes(targetObj, docHashes) {
      const chunkSize = Math.ceil(docHashes.length / targetObj.signatures.length)
      // console.log('updateDocHashes chunkSize', chunkSize)
      // console.log('targetObj.signatures.length', targetObj.signatures.length)
      for (let i = 0; i < targetObj.signatures.length; i++) {
        const startIdx = i * chunkSize
        targetObj.signatures[i].docHashes = docHashes.slice(startIdx, startIdx + chunkSize)
      }
    },

    async signDoc() {
      if (!this.$refs.form.validate()) {
        return
      }

      const credentialRefId = this.selectedCredential?.provider ? this.selectedCredential.id : undefined
      const evroRefId = this.selectedCredential?.isEvro ? this.selectedCredential.id : undefined

      if (this.selectedCredential && this.selectedCredential.provider && credentialRefId && !this.selectedCredential.idToken) {
        console.log('No idToken present for imported credential, asking user to login to external provider')
        await this.getCredentialInfosWithCSC()
        if (!this.selectedCredential.idToken) {
          console.log('No idToken present, aborting sign')
          return
        }
      }

      const isSealSignMode = this.isSealSignMode()

      if (!isSealSignMode) {
        // if (this.useSignatureProfile && this.selectedSignatureProfile) {
        if (this.selectedCredential) {
          let certChainOK = true
          // console.log('this.selectedCredential', this.selectedCredential)

          if (this.selectedCredential && (this.selectedCredential.id !== -1)) {
            if (this.selectedCredential.isEvro && (!this.selectedCredential.certificatePem || this.selectedCredential.certificatePem.length === 0)) {
              certChainOK = false
            }
            if (!this.selectedCredential.provider && !this.selectedCredential.isEvro && (!this.selectedCredential.certChain || this.selectedCredential.certChain.length === 0)) {
              certChainOK = false
            }
            if (this.selectedCredential.provider && (!this.selectedCredential.cert || this.selectedCredential.cert.certificates.length === 0)) {
              certChainOK = false
            }
          }

          if (this.selectedCredential && !certChainOK) {
            showToastError(this.$t('documentSignatureCustomization.content.signature.noCertificateError'))
            return
          }

          if (this.useSignatureProfile && this.selectedSignatureProfile) {
            const profileCredFoundInActivated = !!(this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            const profileCredFoundInImported = !!(this.credentialRefs.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            const profileCredFoundInEvro = !!(this.credentialsEvro.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            if (!profileCredFoundInActivated && !profileCredFoundInImported && !profileCredFoundInEvro) {
              showToastError(this.$t('validation.form.credentialIsDead'))
              return
            }
          }
        }
      }

      const explicitCredential = !isSealSignMode && this.isExplicitCredential(this.selectedCredential)
      const implicitCredential = !isSealSignMode && this.isImplicitCredential(this.selectedCredential)
      const importedCredential = !isSealSignMode && this.selectedCredential.provider
      this.authorizationModalBtnLoading = explicitCredential
      this.isUploading = isSealSignMode

      if (implicitCredential && this.devicesListTotalItems === 0) {
        showToastError(this.$t('documentSignatureCustomization.content.signature.activeCredentialButNoActivatedDeviceError'))
        return
      }

      if (implicitCredential || evroRefId) {
        this.implicitGuid = uuidv4()
      }

      const OAUTH2CODECredential = this.isOAUTH2CODECredential(this.selectedCredential)

      // console.log('singDoc this.selectedCredential', this.selectedCredential)

      try {
        const signRequest = {
          useSeal: isSealSignMode

        }

        if (!isSealSignMode) {
          /* if (credentialRefId) {
            console.log('selected external provider', this.selectedCredential.provider)
          } */

          // console.log('signDoc credentialRefId', credentialRefId)
          // const idToken = await Vue.prototype.$auth.getIdToken(true)

          const credentialOptions = {
            description: this.implicitGuid
          }
          if (credentialRefId) {
            this.$set(credentialOptions, 'credentialRefId', credentialRefId)
            this.$set(credentialOptions, 'authentication', this.selectedCredential.idToken)
          } else
          if (evroRefId) {
            this.$set(credentialOptions, 'evroRefId', evroRefId)
          } else
          if (this.selectedCredential.id) {
            this.$set(credentialOptions, 'credentialId', this.selectedCredential.id)
          }
          if (explicitCredential) {
            this.$set(credentialOptions, 'PIN', this.expAuthPwd.pwd)
          }
          this.$set(signRequest, 'credentialOptions', credentialOptions)
        }

        if (this.pdfEncrypted && this.pdf_password) {
          const documentsOptions = []
          const documentsOption = {
            docId: this.document.id,
            passwordProtection: this.pdf_password
          }
          documentsOptions.push(documentsOption)
          this.$set(signRequest, 'documentsOptions', documentsOptions)
        }

        const signaturesList = []
        const signature = {
          signatureId: !this.$route.params.signatureId != null ? this.$route.params.signatureId : null,
          currentSignatureId: !this.$route.params.currentSignatureId != null ? this.$route.params.currentSignatureId : null,
          comment: this.comment.length > 0 ? this.comment : null
          // signatureFieldParameters: this.selectedSignatureProfile.savedSignatureFieldParameters
        }

        if (this.useVisibleSignature) {
          // console.log('useVisibleSignature')
          if (this.useSignatureProfile && this.selectedSignatureProfile) {
            this.$set(signRequest, 'signatureProfileId', this.selectedSignatureProfile.id)
          } else
          if (this.userDrawedSignatureImage) {
            // console.log('this.selectedSignatureProfile', this.selectedSignatureProfile)
            this.$set(signRequest, 'userImageDataUrl', this.userDrawedSignatureImage)
          }
          // before signature, we asking the current preview position (in case the widget is not moved by hand)
          this.getSignatureFieldParameters()

          const visibleSignature = this.$refs.visibleSignature
          const usedSignatureFieldParameters = visibleSignature.getSignatureFieldParameters()
          // if (this.useSignatureProfile && usedSignatureFieldParameters) {
          if (usedSignatureFieldParameters) {
            this.$set(signature, 'signatureFieldParameters', { ...usedSignatureFieldParameters })
          }
        }

        signaturesList.push(signature)
        this.$set(signRequest, 'signatures', signaturesList)

        try {
          if (implicitCredential || evroRefId) {
            this.implicitAuthorizationModalKey++
            this.ImplicitAuthorizationModalVisible = true
          }
          let providerAuthorizationTimeoutMilis
          let foundProvider
          if (this.selectedCredential.provider) {
            foundProvider = this.getCurrentProvider()
            providerAuthorizationTimeoutMilis = foundProvider.authorizationTimeoutSecs ? foundProvider.authorizationTimeoutSecs * 1000 : 0
            // console.log('providerAuthorizationTimeoutSecs', providerAuthorizationTimeoutMilis)
          }
          const usedAuthorizationTimeoutSecs = this.selectedCredential.isEvro ? this.evroTrustAuthorizationTimeoutMilis : (this.selectedCredential.provider ? providerAuthorizationTimeoutMilis : this.authorizationTimeoutMilis)
          // console.log('usedAuthorizationTimeoutSecs', usedAuthorizationTimeoutSecs)
          if (OAUTH2CODECredential) {
            this.$set(signRequest, 'returnHashes', true)
          }
          // console.log('signRequest', JSON.parse(JSON.stringify(signRequest)))

          const sign1Resp = await signatures.sign(signRequest, (implicitCredential || evroRefId) ? usedAuthorizationTimeoutSecs : null)
          // console.log('sign1Resp', sign1Resp)

          if (OAUTH2CODECredential) {
            let sad
            const docHashes = this.extractDocHashes(sign1Resp)

            if (foundProvider) {
              this.$set(signRequest, 'returnHashes', true)
              const url = window.location.origin
              const settings = {
                authority: foundProvider.oidc.issuer,
                client_id: foundProvider.oidc.clientId,
                popup_redirect_uri: `${url}/popup-callback`,
                response_type: 'code',
                scope: 'credential',
                prompt: foundProvider.oidc.prompt,
                monitorSession: false,
                // popupWindowFeatures: `location=no,toolbar=no,width=${this.popupLoginWidth},height=${this.popupLoginHeight},left=100,top=100`
                popupWindowFeatures: {
                  location: false,
                  menubar: false,
                  toolbar: false,
                  height: this.popupLoginHeight,
                  width: this.popupLoginWidth,
                  closePopupWindowAfterInSeconds: -1
                }
              }
              if (foundProvider.oidc.clientSecret) {
                settings.client_secret = foundProvider.oidc.clientSecret
              }
              let providerBaseURL
              if (foundProvider.oidc.authorizationEndpoint && foundProvider.oidc.tokenEndpoint && foundProvider.oidc.revocationEndpoint) {
                providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
                // console.log('extProviderRDSSBaseURL', providerBaseURL)
                settings.metadata = {
                  authorization_endpoint: foundProvider.oidc.authorizationEndpoint,
                  // token_endpoint: usedOIDC.tokenEndpoint,
                  token_endpoint: providerBaseURL + '/openid/token',
                  revocation_endpoint: foundProvider.oidc.revocationEndpoint
                }
                // settings.extraQueryParams = '{numSignatures: 1, credentialID: ' + this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id + ', hash:' + docHash + ', description: "Please allow RSSP to sign with your key!" }'
                // console.log('signaturesList.length', signaturesList.length)
                // console.log('docHashes.length', docHashes.length)
                settings.extraQueryParams = {
                  numSignatures: docHashes.length,
                  credentialID: this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id,
                  hash: docHashes,
                  description: 'Please allow RSSP to sign with your key!'
                }
                // console.log('settings', settings)
              } else {
                providerBaseURL = foundProvider.apiBaseUrl
              }
              const mgr = new UserManager(settings)
              try {
                const user = await mgr.signinPopup()
                // console.log('User logged in', user)
                if (user.token_type === 'SAD') {
                  // console.log('token_type is SAD')
                  sad = user.access_token
                } else {
                  if (!user.id_token) {
                    // console.log('Empty id_token, using access_token instead', user.access_token)
                    this.selectedCredential.idToken = user.access_token
                  } else {
                    this.selectedCredential.idToken = user.id_token
                  }
                  sad = user.sad
                }
              } catch (error) {
                console.error('An error occured during login.', error)
                showToastError(this.handleCSCErrorMessage(error))
                return
              }
            } else {
              const authorizeCredentialRequest = {
                numSignatures: docHashes.length,
                hash: docHashes
              }
              this.$set(authorizeCredentialRequest, 'credentialID', this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id)
              if (explicitCredential) {
                this.$set(authorizeCredentialRequest, 'PIN', this.expAuthPwd.pwd)
              }
              // console.log('authorizeCredentialRequest', authorizeCredentialRequest)

              const authorizeCredentialResp = await csc.authorizeCredential(this.selectedCredential.providerBaseURL, this.selectedCredential.idToken, authorizeCredentialRequest)
              /* if (this.selectedCredential.provider && foundProvider) {
                console.log('foundProvider', foundProvider)
                console.log('foundProvider.oidc.authorizationEndpoint', foundProvider.oidc.authorizationEndpoint)
                authorizeCredentialResp = await csc.authorizeCredentialExternal(foundProvider.oidc.authorizationEndpoint, this.selectedCredential.idToken, authorizeCredentialRequest)
              } else {
                authorizeCredentialResp = await csc.authorizeCredential(this.selectedCredential.providerBaseURL, this.selectedCredential.idToken, authorizeCredentialRequest)
              } */
              // console.log('authorizeCredentialResp', authorizeCredentialResp)
              sad = authorizeCredentialResp.SAD
            }
            this.$set(signRequest, 'returnHashes', false)
            this.$set(signRequest, 'sad', sad)
            this.updateDocHashes(signRequest, docHashes)
            // this.$set(signRequest, 'signatures', signaturesList)
            // console.log('signRequest2', JSON.parse(JSON.stringify(signRequest)))
            const sign2Resp = await signatures.sign(signRequest, implicitCredential ? usedAuthorizationTimeoutSecs : null)
            // console.log('sign2Resp', sign2Resp)
          }
          this.back()
          showToastSuccess(this.$t('toastMessage.succesfullySigned'))
        } catch (error) {
          if (error?.response?.data?.code === CommonError.SERVICE_UNAVAILABLE) {
            showToastError(this.$t('documentSignatureCustomization.content.signature.toastMessages.sicAborted'))
          } else {
            const errorMsg = this.getErrorMessage(error)
            showToastError(errorMsg)
          }
          console.log(error)
        }
      } catch (error2) {
        console.error('signDoc, exception occured', error2)
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.authorizationModalBtnLoading = false
        this.isUploading = false
        this.ImplicitAuthorizationModalVisible = false
        this.authorizationModal = false
      }
    },

    isExplicitCredential(credential) {
      return credential && (credential.authMode === CredentialAuthMode.EXPLICIT)
    },

    isImplicitCredential(credential) {
      return credential && (credential.authMode === CredentialAuthMode.IMPLICIT)
    },

    isOAUTH2CODECredential(credential) {
      return credential && (credential.authMode === 'OAUTH2CODE')
    },

    isCredentialUnknownAuthMode(credential) {
      return credential && (!credential.authMode)
    },

    isSealSignMode() {
      // console.log('isSealSignMode()', this.sealActivated, this.activatedCredentials.length, this.selectedSignatureProfile, this.selectedCredential)
      // return (!!(this.sealActivated && ((this.activatedCredentials.length === 0 && this.credentialRefs.length === 0) || (this.selectedCredential && this.selectedCredential.id && this.selectedCredential.id === this.centralKeyId))))
      return (!!(this.sealActivated && ((this.activatedCredentials.length === 0 && this.credentialRefs.length === 0 && this.credentialsEvro.length === 0) ||
      (this.useSignatureProfile && this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal && !this.useDifferentCredential) ||
      (this.selectedCredential && this.selectedCredential.id && this.selectedCredential.id === this.centralKeyId))))
    },

    back() {
      this.declineReasonVisible = false
      this.$router.push({ name: 'SignatureChains' })
    },

    getSignatureFieldParameters() {
      const visibleSignatureComponent = this.$refs.visibleSignature

      if (visibleSignatureComponent) {
        const signatureImageFieldParameters = visibleSignatureComponent.getSignatureFieldParameters()
        if (signatureImageFieldParameters) {
          this.selectedSignatureProfile.savedSignatureFieldParameters = Object.assign({}, this.selectedSignatureProfile.savedSignatureFieldParameters, signatureImageFieldParameters)
        }
      } else {
        console.error('visibleSignature component not found.')
      }
    },

    async getVerificationDetails() {
      try {
        /* const req = {
          transactionId: 'a3ca2b6d-b28e-442c-86d4-394e41d13a6d',
          processParam: {
            scenario: 'FullAuth'
          }
        }
        await userVerification.processRegula(req) */
        this.userVerificationStatus = await userVerification.getUserVerificationStatus()
        this.userVerified = this.userVerificationStatus.verified
        // console.log('this.userVerificationStatus', this.userVerificationStatus)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    checkFormValidity() {
      // Check if the form is valid
      if (this.$refs.form.validate()) {
        this.formValid = true
        // console.log('checkFormValidity form validation true')
      } else {
        // console.log('checkFormValidity form validation false')
        // Log validation errors for debugging
        // console.log(this.$refs.form.errorBag)
        // Log validation errors for debugging
        // this.logValidationErrors()
      }
    },
    logValidationErrors() {
      // Check if errorBag exists and is an object
      if (this.$refs.form.errorBag && typeof this.$refs.form.errorBag === 'object') {
        // Iterate through errorBag and log error messages and rules
        for (const fieldName in this.$refs.form.errorBag) {
          const fieldErrors = this.$refs.form.errorBag[fieldName]
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(error => {
              console.log(`Field: ${fieldName}, Error Message: ${error}, Rule: ${error.rule}`)
            })
          } else if (typeof fieldErrors === 'string') {
            console.error(`Field: ${fieldName}, Error Message: ${fieldErrors}`)
          } else {
            // Handle if fieldErrors is not an array or string
            console.error(`Unexpected errorBag structure for field ${fieldName}:`, fieldErrors)
          }
        }
      } else {
        console.error('ErrorBag is not properly defined or is not an object')
      }
    },
    handleFormValidityChange(valid) {
      // valid parameter indicates whether the form is valid or not
      if (!valid) {
        // console.log('Form validation error occurred.')
        // Additional actions you may want to take when a validation error occurs
        // this.logValidationErrors()
      }
    },
    findCredentialByRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (item.provider && parseInt(item.id) === searchId))
      return matchingCredential
    },
    findCredentialByEvroRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (item.isEvro && parseInt(item.id) === searchId))
      return matchingCredential
    },
    findCredentialById(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (!item.provider && !item.isEvro && parseInt(item.id) === searchId))
      return matchingCredential
    },
    getCredentialItemText(item) {
      if (item.provider) {
        return `${item.description} | external: ${item.provider}`
      } else {
        if (item.isEvro) {
          return `${item.description} | evrotrust`
        } else {
          return item.description
        }
      }
    },
    openSignatureModal() {
      this.$refs.signatureDrawer.dialog = true
    },
    async handleCustomSignature(imageData) {
      // console.log('handleCustomSignature', imageData)

      if (!this.selectedSignatureProfile) {
        this.selectedSignatureProfile = {}
      }
      this.userDrawedSignatureImage = imageData

      const req = {
        userImageDataUrl: imageData,
        subsignerName: null
      }
      const mergedBase64 = await signatures.combineImage(req)
      this.selectedSignatureProfile.sourceImageDataUrl = mergedBase64.imageDataUrl

      if (this.predefinedSignatureParams) {
        this.selectedSignatureProfile.savedSignatureFieldParameters = this.predefinedSignatureParams
      }

      this.$nextTick(() => {
        const visibleSignatureComponent = this.$refs.visibleSignature
        visibleSignatureComponent.updateSignatureProfile(this.selectedSignatureProfile)
      })
    },
    setSignatureImage(file, imageDataUri, callPreview = true) {
      // console.log('setSignatureImage', imageDataUri)
      let updatedDataUri = ''
      const splittedSigImgDataUrl = imageDataUri.split(';')
      updatedDataUri = updatedDataUri.concat(splittedSigImgDataUrl[0], ';filename=' + file.name + ';', splittedSigImgDataUrl[1])
      // console.log('setSignatureImage updatedDataUri', updatedDataUri)
      this.$set(this.signatureProfile, 'sourceImageDataUrl', updatedDataUri)
      // console.log('setSignatureImage this.signatureProfile.imageDataUrl', this.signatureProfile.imageDataUrl)
      if (callPreview) {
        this.initPreview()
      }
    },
    useCustomSignatureClick() {
      this.useSignatureProfile = false
      this.useCustomDrawnSignatureImage = true
      this.openSignatureModal()
    },
    useSignatureProfileClick() {
      this.useCustomDrawnSignatureImage = false
      this.useSignatureProfile = true
    },
    clearCutomSignatureImageClick() {
      this.useCustomDrawnSignatureImage = false
      this.userDrawedSignatureImage = null
      if (this.selectedSignatureProfile) {
        this.selectedSignatureProfile.sourceImageDataUrl = undefined
        this.$nextTick(() => {
          const visibleSignatureComponent = this.$refs.visibleSignature
          visibleSignatureComponent.updateSignatureProfile(this.selectedSignatureProfile)
        })
      }
      this.useSignatureProfile = false
    },
    async declineDoc() {
      const signRequest = {
        signatureId: !this.$route.params.signatureId != null ? this.$route.params.signatureId : null,
        currentSignatureId: !this.$route.params.currentSignatureId != null ? this.$route.params.currentSignatureId : null,
        comment: this.comment.length > 0 ? this.comment : null
      }
      const signatureId = this.$route.params.signatureId
      try {
        await signatures.decline(signatureId, signRequest)
        showToastSuccess(this.$t('toastMessage.succesfullyDeclined'))
        this.$emit('declined')
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },
    base32Encode(input) {
      const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'
      const bytes = new TextEncoder().encode(input)
      let bits = ''
      let base32 = ''

      for (const byte of bytes) {
        bits += byte.toString(2).padStart(8, '0')
      }

      for (let i = 0; i < bits.length; i += 5) {
        const chunk = bits.substring(i, i + 5)
        if (chunk.length < 5) {
          base32 += alphabet[parseInt(chunk.padEnd(5, '0'), 2)]
        } else {
          base32 += alphabet[parseInt(chunk, 2)]
        }
      }

      // Optional: pad output to a multiple of 8 characters with '='
      while (base32.length % 8 !== 0) {
        base32 += '='
      }

      return base32
    },
    handleExternalSignatureUploaded(e) {
      if (e === null) e = []
      // console.log(e)
      this.uploadedExternalFile = e[0]
      if (e[0]) {
        this.uploadedExternalFileName = e[0].name.slice(0, -4)

        // console.log('this.uploadedExternalFileName', this.uploadedExternalFileName)

        if (this.chain.type === signatureChainType.UNORDERED) {
          const ids = this.extractIds(this.uploadedExternalFile.name)
          // console.log('ids', ids)

          this.externalSignatureIdsCorrect = (ids.chainId === Number(this.chain.id)) && (ids.currentSignatureId === (this.$route.params.currentSignatureId ? Number(this.$route.params.currentSignatureId) : null))
          /* console.log('this.chain.id', this.chain.id)
          console.log('ids.chainId', ids.chainId)
          console.log('ids.currentSignatureId', ids.currentSignatureId)
          console.log('typeof ids.currentSignatureId', typeof ids.currentSignatureId)
          console.log('this.$route.params.currentSignatureId', this.$route.params.currentSignatureId)
          console.log('typeof this.$route.params.currentSignatureId', typeof this.$route.params.currentSignatureId)
          console.log('(ids.chainId === this.chain.id)', (ids.chainId === this.chain.id))
          console.log('this.externalSignatureIdsCorrect', this.externalSignatureIdsCorrect) */
          if (!this.externalSignatureIdsCorrect) {
            showToastError(this.$t('backendErrors.SIGNATURE_CHAIN_CONCURRENT_MODIFICATION'))
          }
        } else {
          this.externalSignatureIdsCorrect = true
        }
        // console.log('this.uploadedExternalFile', this.uploadedExternalFile)
      } else {
        this.externalSignatureIdsCorrect = false
      }
    },
    extractIds(filename) {
      // Extract the base name without extension
      const base = filename.split('/').pop().split('.')[0]

      // console.log('base', base)

      // Match the last one or two numeric parts surrounded by underscores
      const match = base.match(/_(\d+)(?:_(\d+))?_?$/)

      // console.log('match', match)

      if (match) {
        const chainId = parseInt(match[1], 10)
        const currentSignatureId = match[2] ? parseInt(match[2], 10) : null

        return { chainId, currentSignatureId }
      }

      return { chainId: null, currentSignatureId: null }
    },
    async getDownloadFileName(fileName, mode, chainId, currentSignatureId) {
      if (!this.rsspRemoteConf) {
        this.rsspRemoteConf = await rssp.getRemoteConfig()
      }
      const encodedServiceId = this.rsspRemoteConf.serviceId ? this.base32Encode(this.rsspRemoteConf.serviceId) : ''
      /* console.log('serviceId', this.rsspRemoteConf.serviceId)
      console.log('encodedServiceId', encodedServiceId) */

      const lastDotIndex = fileName.lastIndexOf('.')

      const hasExtension = lastDotIndex !== -1
      const nameWithoutExt = hasExtension ? fileName.substring(0, lastDotIndex) : fileName
      const extension = hasExtension ? fileName.substring(lastDotIndex) : ''

      /* console.log('fileName', fileName)
      console.log('nameWithoutExt', nameWithoutExt)
      console.log('extension', extension) */

      // console.log('currentSignatureId', currentSignatureId)

      const usedCurrentSignatureId = currentSignatureId || ''

      // console.log('usedCurrentSignatureId', usedCurrentSignatureId)

      if (mode === documentDownloadMode.ORIGINAL && extension.toLowerCase() === '.pdf') {
        return fileName + '_rdss_' + encodedServiceId + '_' + chainId + '_' + usedCurrentSignatureId + '.' + extension
      }
      if (mode === documentDownloadMode.ORIGINAL && extension.toLowerCase() !== '.pdf') {
        return fileName + '_rdss_' + encodedServiceId + '_' + chainId + '_' + usedCurrentSignatureId + '.' + '.pdf'
      }

      // return nameWithoutExt + '-signingtrail' + (hasExtension ? extension : '.pdf')
      return fileName + '_rdss_' + encodedServiceId + '_' + chainId + '_' + usedCurrentSignatureId + (hasExtension ? extension : '.pdf')
    },
    async downloadForExternalSign(e) {
      // getting the latest document

      this.isUploading = true
      try {
        // console.log('chain', this.chain)
        let mode = this.chain.signingTrailMode
        if (!mode || mode === 'NONE') {
          // mode = documentDownloadMode.DETACHED
          mode = documentDownloadMode.ORIGINAL
        }
        // const mode = documentDownloadMode.DETACHED
        // console.log('mode', mode)

        if (mode === documentDownloadMode.FULL) {
          showToastError(this.$t('documentSignatureCustomization.content.signature.externalSignature.asicNotSupported'))
          return
        }

        const blob = await documents.downloadDocument(this.$route.params.docId)
        const docuDto = await documents.getDocument(this.$route.params.docId)
        // console.log('docuDto', docuDto)

        // const fileName = docuDto.fileName.replace(/\.[^/.]+$/, '')
        const fileName = this.chain.origDocument.fileName.replace(/\.[^/.]+$/, '')

        // console.log('fileName', fileName)
        // console.log('this.$route.params', this.$route.params)
        const downloadFileName = await this.getDownloadFileName(fileName, mode, this.chain.id, this.$route.params.currentSignatureId != null ? this.$route.params.currentSignatureId : null)
        // console.log('downloadFileName', downloadFileName)
        // this.pdfEncrypted = (docuDto.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (docuDto.security === 'ENCRYPTED_WITH_USER_PASSWORD')
        // const base64 = await this.blobToBase64(blob)
        // this.documentBase64 = base64.split(',')[1]

        await FileSaver.saveAs(blob, downloadFileName)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
      this.isUploading = false
    },
    async uploadExternalSignedDocument(e) {
      let docDto
      try {
        docDto = await documents.uploadDocument(this.uploadedExternalFileName, this.uploadedExternalFile, 'EXTERNAL_SIGNATURE')
        // console.log('uploaded external signature docDto', docDto)
        // const docId = this.$route.params.docId
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
      if (docDto === undefined) {
        return
      }
      const signaturesList = []
      const signature = {
        signatureId: !this.$route.params.signatureId != null ? this.$route.params.signatureId : null,
        currentSignatureId: !this.$route.params.currentSignatureId != null ? this.$route.params.currentSignatureId : null,
        externalSignedDocId: docDto.id,
        comment: this.comment.length > 0 ? this.comment : null
      }
      signaturesList.push(signature)
      const signRequest = {
        signatures: signaturesList
      }
      try {
        // console.log('signRequest', signRequest)
        const signResponse = await signatures.sign(signRequest)
        // console.log('signResponse', signResponse)
        this.$store.commit('removeCurrentFile')

        this.back()
        showToastSuccess(this.$t('toastMessage.succesfullySubmitted'))
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
      //
      // this.$set(signRequest, 'signatures', signaturesList)
    }
  }
}
</script>

<style>
.BlueWarning {
  color: var(--v-accent-base);
}
</style>
